import {FC, useEffect, useRef, useState} from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import firebase from "firebase";
import {IDataAnime} from '../../Data/Anime';
import Chip from '@material-ui/core/Chip';
import SkorAnime from './komponenAnime/skorAnime/SkorAnime'
import './AnimeModal.scss';
import ShowMoreText from "react-show-more-text";
import IkonTambah from '@material-ui/icons/Add'
import { Fab } from '@material-ui/core';

export const AnimeModal: FC<ILamanAnime> = (prop) =>  {

  useEffect(() => {
    fetchAnime();
  }, [prop.idAnime]);

  const refDivKosong = useRef<HTMLDivElement | null>(null)
  const[anime, setAnime] = useState<IDataAnime | null>(null);
  const fetchAnime = async () => {
    if(prop.idAnime){
      const animeDapat = await dapatkanAnime(
        (decodeURIComponent(prop.idAnime.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25')))
      )
      setAnime(animeDapat)
    }
  };

  const [tanggalTayangString, setTanggalTayangString] = useState('--/--/----')

  useEffect(() => {
    if(anime != null){
      if(anime.tanggalMulaiTayang != null){
        const t = new Date(anime.tanggalMulaiTayang.seconds * 1000)
        setTanggalTayangString(t.getDate() + '/' + (t.getMonth() + 1) + '/' + t.getFullYear())
      }else{
        setTanggalTayangString('Belum tayang')
      }
    }
    refDivKosong.current?.scrollIntoView()
  }, [anime])

  

  return (
    <section className="konten-anime-modal-apl-animemo">
      <div ref={refDivKosong} className='div-kosong'/>
      <h2 className='judul-anime'>
        {anime?.judulAnime || '-'}
      </h2>
      <img src={anime?.urlFotoAnime || undefined} className="gambar-anime" alt="Foto Anime" />
      <div className='kontainer-seluruh-skor'>
        <SkorAnime teks='Skor AniMemo' skorAnime={anime?.skor}/>
        <SkorAnime teks='Skor MAL' skorAnime={anime?.skorMal}/>
      </div>
      <ul className='genre-anime'>
        {anime?.genre?.map((nilai, kunci) => {
          return <Chip style={{marginLeft: 2, marginRight: 2, marginBottom: 5}}label={nilai}/>
        })}
      </ul>
      <div className='teks-header-kecil'>
        {(anime?.jenisAcara ? anime?.jenisAcara : '?' ) + ', ' +
        (anime?.episodeAnime ? anime?.episodeAnime : '?') + ' episode' + ', '
      }
      </div>
      <div className='kontainer-teks-sinopsis'>
        <ShowMoreText
          lines={2}
          more="Lebih banyak"
          less="Lebih sedikit"
          expanded={false}
        >
          {anime?.sinopsis}
        </ShowMoreText>
      </div>
      <div className='teks-header-kecil'>
        info lebih
      </div>
      <table className='isi-tabel-anime'>
        <TabelAnime
        judul='Judul alternatif'
        dataTabel={'-' + anime?.judulAlternatif?.join('\n-')}
        />
        <TabelAnime
        judul='Judul jepang'
        dataTabel={anime?.judulJepangAnime}
        />
        <TabelAnime
        judul='Tanggal mulai tayang'
        dataTabel={tanggalTayangString}
        />
        {//TODO selesai tayang
        }
        <TabelAnime
        judul='Produser'
        dataTabel={'-' + anime?.produser?.join('\n-')}
        />
        <TabelAnime
        judul='Lisensor'
        dataTabel={'-' + anime?.lisensor?.join('\n-')}
        />
        <TabelAnime
        judul='Studio'
        dataTabel={'-' + anime?.studio?.join('\n-')}
        />
        <TabelAnime
        judul='Sumber cerita'
        dataTabel={anime?.sumberCerita}
        />
        <TabelAnime
        judul='Rating Anime'
        dataTabel={anime?.ratingAnime + ' | ' + anime?.alasanRating  }
        />
        <TabelAnime
        judul='Musik opening'
        dataTabel={'-' + anime?.musikOpening?.join('\n\n-')}
        />
        <TabelAnime
        judul='Musik ending'
        dataTabel={'-' + anime?.musikEnding?.join('\n\n-')}
        />
      </table>
      
      <br/>
      <br/>
      <div className='fab-tambah-anime'>
        <Link to={'/h/tambahkan-anime/' + encodeURIComponent(anime?.idAnime || "") }>
          <Fab color='primary' >
            <IkonTambah />
          </Fab>
        </Link>
      </div>
    </section>
  );
}

const TabelAnime: FC<ITabelAnime> = (p) => {
  return(
    <tr>
      <td className='bagian-kiri-tabel-anime'>{p.judul}</td>
      <td className='bagian-kanan-tabel-anime'>{p.dataTabel}</td>
    </tr>
  )
}

async function dapatkanAnime(idAnime?: string){
  const db = firebase.firestore()
  const kolRefAnime = db.collection('databaseAnime')
  const dokAnime: any = (await kolRefAnime.doc(idAnime || '').get()).data()
  const anime: IDataAnime = dokAnime
  return anime
}


interface ILamanAnime {
  idAnime: string | null
}

interface ITabelAnime {
  judul?: string,
  dataTabel?: string | null,
}